import { developerToolsEnabled } from "@/shared/config/env";
import type { RouteRecordRaw } from "vue-router";
import type { MenuRoute } from "@/shared/types/route";
import {
  DEVELOP_PATH,
  DEV_CLODOP_TEMPLATE_PATH,
  DEV_PLATFORM_PRINT_PATH,
  DEV_PRINT_DESIGNER_PATH,
} from "../constants";

const layoutComponent = () => import("@/widgets/app-shell/AppShell.vue");

export const developMenuRoutes: MenuRoute[] = developerToolsEnabled
  ? [
      {
        path: DEVELOP_PATH,
        name: "Develop",
        title: "开发调试",
        icon: "code",
        redirect: DEV_CLODOP_TEMPLATE_PATH,
        children: [
          {
            path: DEV_CLODOP_TEMPLATE_PATH,
            name: "DevelopCLodopTemplateDebug",
            title: "C-Lodop 模板调试",
            icon: "file-text",
          },
          {
            path: DEV_PRINT_DESIGNER_PATH,
            name: "DevelopPrintDesignerDebug",
            title: "打印设计器调试",
            icon: "printer",
          },
          {
            path: DEV_PLATFORM_PRINT_PATH,
            name: "DevelopPlatformPrintDebug",
            title: "平台面单打印调试",
            icon: "printer",
          },
        ],
      },
    ]
  : [];

export const publicDevelopRoutes: RouteRecordRaw[] = developerToolsEnabled
  ? [
      {
        path: DEVELOP_PATH,
        name: "Develop",
        component: layoutComponent,
        redirect: DEV_CLODOP_TEMPLATE_PATH,
        meta: {
          title: "开发调试",
          public: true,
        },
        children: [
          {
            path: "clodop-template",
            name: "DevelopCLodopTemplateDebug",
            component: () => import("@/pages/dev/clodop-template/index.vue"),
            meta: {
              title: "C-Lodop 模板调试",
              public: true,
            },
          },
          {
            path: "print-designer-debug",
            name: "DevelopPrintDesignerDebug",
            component: () => import("@/pages/dev/print-designer-debug/index.vue"),
            meta: {
              title: "打印设计器调试",
              public: true,
            },
          },
          {
            path: "platform-print-debug",
            name: "DevelopPlatformPrintDebug",
            component: () => import("@/pages/dev/platform-print-debug/index.vue"),
            meta: {
              title: "平台面单打印调试",
              public: true,
            },
          },
        ],
      },
    ]
  : [];
